import React, { useState } from 'react';

function AdminLogin({ onLogin }) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!password.trim()) {
      setError('Wprowadź hasło administratora.');
      return;
    }

    localStorage.setItem('adminAuthenticated', 'true');
    onLogin(true);
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <form onSubmit={handleSubmit} className="bg-white border border-gray-200 rounded-lg p-6 w-full max-w-md">
        <h1 className="text-xl font-semibold text-gray-900 mb-4">Logowanie administratora</h1>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Hasło"
          className="w-full p-3 border border-gray-300 rounded-lg"
        />
        {error && <p className="mt-2 text-sm text-red-600">{error}</p>}
        <button type="submit" className="mt-4 w-full bg-gray-900 text-white py-2.5 rounded-lg">
          Zaloguj
        </button>
      </form>
    </div>
  );
}

export default AdminLogin;
